class HeaderNav extends HTMLElement {
  constructor() {
    super();
    this.contentForLayout = document.querySelector(".content-for-layout");
    this.headerNav = document.querySelector("header-nav");
    this.header = document.querySelector(".section-header");
    this.headerContainer = document.querySelector(".header-container");
    this.prevScrollpos = window.scrollY;
    this.opened = false;
    this.mobileMenu = document.querySelector(".mobile-menu");
    this.body = document.querySelector("body");
    this.headerContentContainer = document.querySelector(
      ".header-content-container"
    );
    this.nav = document.querySelector(".primary-navbar");
    this.menuItems = document.querySelectorAll(".primary-menu__item");
    this.headerContents = document.querySelectorAll(".header-content");
    this.bgBlur = document.querySelector(".bg-blur");
    this.hamburger = document.querySelector(".header .hamburger");
    this.closeBtn = document.querySelector(".menu-header__close");
    this.closeBtn2 = document.querySelector(".menu-header__close2");
    this.page1 = document.querySelector('.mobile-menu-page-1');
    this.page2 = document.querySelector('.mobile-menu-page-2');
    this.platFormButton = document.querySelector("#platform-nav-link")
    this.backButton = document.querySelector(".back-to-main-menu")

    if (window.location.pathname === "/cart") {
      this.contentForLayout.classList.add("cart-page");
      this.headerNav.classList.add("cart-page");
    }

    window.onscroll = () => {
      this.stickyHeader();
    };

    // window.addEventListener("popstate", (e) => {
    //   if (this.opened) {
    //     // window.history.pushState(null, null, '');
    //     closeMobileMenu();
    //   }
    // });

    this.headerContainer.addEventListener("mouseleave", () =>
      this.hideContent()
    );

    this.menuItems.forEach((item, index) =>
      item.addEventListener("mouseenter", (e) =>
        this.showContent(e, item, index + 1)
      )
    );

    this.header.addEventListener(
      "mouseenter",
      () => (this.header.style.top = "0")
    );
    this.header.addEventListener("click", () => (this.header.style.top = "0"));
    this.hamburger.addEventListener("click", () => this.openMobileMenu());
    this.closeBtn.addEventListener("click", () => this.closeMobileMenu());
    this.closeBtn2.addEventListener("click", () => this.closeMobileMenu());
    // #platform-nav-link only renders when the header has a mobile_menu block
    if (this.platFormButton) {
      this.platFormButton.addEventListener("click", () => {
        document.querySelector('.mobile-menu').classList.add('page-2-active');
      });
    }
    if (this.backButton) {
      this.backButton.addEventListener("click", () => {
        document.querySelector('.mobile-menu').classList.remove('page-2-active');
      })
    }
  }

  handlePlatformClick () {
    // Slide out page 1 and slide in page 2
    this.page1.classList.add('slide-out');
    this.page2.classList.add('slide-in');
    
    // Optional: Remove active class from page 1 after the animation completes
    setTimeout(() => {
      this.page1.classList.remove('active');
    }, 300); // 300ms matches the CSS transition time
  }

  stickyHeader() {
    const stopScroll = document.querySelector("#stop-scroll");
    if(stopScroll === null){
      const currentScrollPos = window.scrollY;
      if (this.prevScrollpos > currentScrollPos) {
        this.header.style.top = "0";
      } else {
        window.matchMedia("(min-width: 1024px)").matches
          ? (this.header.style.top = "-30px")
          : (this.header.style.top = "0px");
      }
      this.prevScrollpos = currentScrollPos;
    }
  }

  openMobileMenu() {
    this.opened = true;
    // window.history.pushState(null, null, '');
    this.header.style.top = "0";
    this.body.classList.add("overflow-hidden");
    this.mobileMenu.classList.add("mobile-menu--show");

    history.pushState({ menu: "open" }, "", "");
    window.addEventListener("popstate", this.closeMobileMenu.bind(this));

    Intercom('update', {
      "hide_default_launcher": true
    });
  }

  closeMobileMenu() {
    this.opened = false;
    this.header.style.top = "0";
    // window.history.back();
    this.body.classList.remove("overflow-hidden");
    this.mobileMenu.classList.remove("mobile-menu--show");
    window.removeEventListener("popstate", this.closeMobileMenu.bind(this));
    if (history.state && history.state.menu === "open") {
      history.back();
    }
    setTimeout(() => {
      this.mobileMenu.classList.remove('page-2-active');
    }, 1000);

    const buyBox = document.querySelector(".product__buy");
    if (buyBox) {
      var rect = buyBox.getBoundingClientRect();
      var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      const isVisible = !(rect.bottom < 0 || rect.top - viewHeight >= 0);
      if (!isVisible) {
        Intercom('update', {
          "hide_default_launcher": false
        }); 
      }
    }
  }

  removeActiveStyle() {
    this.menuItems.forEach((item) => {
      item.classList.remove("primary-menu__item--active");
    });
  }

  removeTransition() {
    this.headerContents.forEach((content) => {
      content.classList.remove("header-content--fade");
      content.classList.remove("header-content--visible");
    });
  }

  // Show header content when hovering the links
  showContent(e, el, num) {
    const headerContent = document.getElementById(`header-content-${num}`);
    this.bgBlur.classList.add("blur");
    this.header.style.top = "0";
    this.removeActiveStyle();
    this.removeTransition();
    headerContent.classList.add("header-content--visible");
    setTimeout(() => headerContent.classList.add("header-content--fade"), 20);
    el.classList.add("primary-menu__item--active");
    this.nav.classList.add("active");
    if(num === 4){
      this.headerContentContainer.classList.add("header-content-container--show-large");
      this.headerContentContainer.classList.remove(
        "header-content-container--show"
      );
    } else {
      this.headerContentContainer.classList.add("header-content-container--show");
      this.headerContentContainer.classList.remove(
        "header-content-container--show-large"
      );
    }
  }
  hideContent() {
    const stopScroll = document.querySelector("#stop-scroll");
    if(stopScroll === null){

      this.bgBlur.classList.remove("blur");
      this.removeActiveStyle();
      this.headerContents.forEach((content) => {
        content.classList.remove("header-content--fade");
      });
      window.scrollY == 0
        ? (this.header.style.top = "0")
        : (this.header.style.top = "-30px");
      this.nav.classList.remove("active");
      this.headerContentContainer.classList.remove(
        "header-content-container--show"
      );
      this.headerContentContainer.classList.remove(
        "header-content-container--show-large"
      );
    }

  }
}

// Slideable announcement block initialization
$(document).ready(() => {
  customElements.define("header-nav", HeaderNav);
  $("#announcement-wrapper").slick({ arrows: false });
  $("#announcement-wrapper").css("visibility", "visible");
});

$(document).ready(() => {
  const navLogo = document.querySelector("#navbar-logo-dot")
  const navText = document.querySelector("#navbar-text-alt")
  const path = window.location.pathname;
  const pathParts = path.split('/');
  const slug = pathParts[pathParts.length - 1];
  if(slug === "card-5-reasons"){
    console.log("test")
   navLogo.classList.add("nav-item-hide")
   navText.classList.remove("nav-item-hide")
  } else {
 
  }
 })


// Dynamic products based on last product viewed for mobile menu
function dynamicProducts() {
  let productItem = localStorage.getItem("lastViewedProduct");
  if (productItem) {
    productItem = JSON.parse(productItem)
  } else {
    return;
  }

  let productCards = [
    ...document.querySelectorAll(".mobile-menu-content .product-card"),
  ];
  if(productItem.title === "dot.wallet"){
    productCards.forEach(
      (productCard) =>
        !productCard.dataset.title.includes(productItem.title) &&
        !productItem.title.includes(productCard.dataset.title) &&
        productCard.dataset.title !== "dot.card" &&
        productCard.remove()
    );
  } else {
    productCards.forEach(
      (productCard) =>
        !productCard.dataset.title.includes(productItem.title) &&
        !productItem.title.includes(productCard.dataset.title) &&
        productCard.remove()
    );
  }
}
const product = document.getElementById("shopify-product-item");
product && localStorage.setItem("lastViewedProduct", product.textContent);
dynamicProducts();

